var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parameters-config"},_vm._l((_vm.values),function(param,i){return _c('input-container',{key:param.name,model:{value:(_vm.values[i]),callback:function ($$v) {_vm.$set(_vm.values, i, $$v)},expression:"values[i]"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }